import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, makeStyles } from '@material-ui/core';
import ArrowTooltip from '../../arrowTooltip';
import { calculatePercentageToNDecimals } from '../../../../utility/helpers';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  label: {
    color: primary.indigo,
    marginRight: spacing(2),
  },
  percentage: {
    color: primary.indigo,
  },
  completedWrapper: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexShrink: 0,
    width: 42,
  },
  barContainer: {
    width: 24,
    height: 2,
    borderRadius: 30,
    backgroundColor: primary.bluish5,
  },
  bar: {
    height: 2,
    backgroundColor: primary.bluish1,
  },
  tooltip: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const CompletedInfo = ({
  className = undefined,
  label,
  allReviewers,
  finishedCount,
}) => {
  const classes = useStyles();

  const tooltipText = (
    <div className={classes.tooltip}>
      <Typography variant="subtitle1" component="span">
        {finishedCount}
      </Typography>
      <Typography
        variant="body1"
        component="span"
      >{`/${allReviewers}`}</Typography>
    </div>
  );
  const completedPercentage = `${calculatePercentageToNDecimals(
    finishedCount,
    allReviewers
  )}%`;

  return (
    <div className={classNames(classes.root, className)}>
      <Typography variant="body1" className={classes.label}>
        {label}
      </Typography>
      <ArrowTooltip className={classes.tooltip} tooltipLabel={tooltipText}>
        <div className={classes.completedWrapper}>
          <Typography
            className={classes.percentage}
            variant="subtitle1"
            component="span"
          >
            {completedPercentage}
          </Typography>
          <div className={classes.barContainer}>
            <div
              className={classes.bar}
              style={{
                width: completedPercentage,
              }}
            />
          </div>
        </div>
      </ArrowTooltip>
    </div>
  );
};

CompletedInfo.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  allReviewers: PropTypes.number.isRequired,
  finishedCount: PropTypes.number.isRequired,
};

export default CompletedInfo;
